<template>
  <div class="calibrations">
    <span style="font-size: large">age from </span>
    <a-input style="width: 20%" v-model="start" />
    <span style="font-size: large; margin-left: 20px; margin-right: 20px"
      >to</span
    >
    <a-input style="width: 20%" v-model="end" />
    <span style="font-size: large">Ma</span>
    <div class="btn">
      <a-button type="primary" @click="Search"> Search </a-button>
      <a-button @click="handleOk">download</a-button>
      <a-modal
        title="download"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <a-input v-model="downloadPassword" />
      </a-modal>
    </div>
    <a-table :columns="columns" :data-source="data">
      <a slot="name" slot-scope="text">{{ text }}</a>
    </a-table>
  </div>
</template>

<script>
import { findHoleByAgerange } from '@/api/index';
import ExportExcel from '@/utils/exportExcel';
const columns = [
  {
    title: 'Leg',
    dataIndex: 'leg_Hole',
    key: 'leg_Hole',
    defaultSortOrder: 'ascend',
    sorter: (a, b) => b.leg_Exp - a.leg_Exp,
  },
  {
    title: 'Site',
    dataIndex: 'site',
    key: 'site',
  },
  {
    title: 'Hole',
    dataIndex: 'hole',
    key: 'hole',
  },
  {
    title: 'Latitude',
    dataIndex: 'latitude',
    key: 'latitude',
  },
  {
    title: 'Longitude',
    dataIndex: 'longitude',
    key: 'longitude',
  },
  {
    title: 'Url',
    dataIndex: 'Url',
    key: 'Url',
  },
];

export default {
  name: 'CalibrationsName',
  data() {
    return {
      start: 0,
      end: 0,
      columns: columns,
      data: [],
      visible: false,
    };
  },
  methods: {
    Search() {
      console.log(
        this.start,
        this.end,
        this.start >= 0,
        this.end <= 270,
        parseInt(this.start) < parseInt(this.end)
      );
      if (
        this.start >= 0 &&
        this.end <= 270 &&
        parseInt(this.start) < parseInt(this.end)
      ) {
        findHoleByAgerange(this.start, this.end).then((res) => {
          this.data = res;
        });
      }
    },
    showModal() {
      this.visible = true;
    },
    toExcel() {
      ExportExcel(this.columns, this.data, 'sedst');
    },
    handleOk() {
      // if (this.downloadPassword !== 'Malabcode') {
      //   this.$message.error('Code Error！');
      //   return;
      // }
      this.confirmLoading = true;
      this.toExcel();
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.flex-container {
  padding: 30px;
  display: flex;
  justify-content: space-around;
}
.calibrations {
  height: 800px;
  padding: 50px;
}
.info-container {
  text-align: center;
  padding: 20px;
}
.btn {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>
